import {
  isArrayPopulated,
  isValueLessThanMin,
  isValueGreaterThanMax,
  isValueInRange,
  isTimeLessThanMinTime,
  isTimeGreaterThanMaxTime,
} from './valueValidations';

export const required = (value) => {
  return value ? null : 'Este campo es requerido';
};

export const requiredArray = (value) => {
  return isArrayPopulated(value) ? null : 'Este campo es requerido';
};

export const minValue = (min) => (value) => {
  return !isValueLessThanMin(min, value) ? null : `Valor mínimo permitido: ${min}`;
};

export const maxValue = (max) => (value) => {
  return !isValueGreaterThanMax(max, value) ? null : `Valor máximo permitido: ${max}`;
};

export const rangeValue = (min, max) => (value) => {
  return isValueInRange(min, max, value) ? null : `El valor debe estar entre ${min} y ${max}`;
};

export const minTime = (min, timeFormat) => (value) => {
  return !isTimeLessThanMinTime(min, value, timeFormat) ? null : `Hora mínima permitida: ${min}`;
};

export const maxTime = (max, timeFormat) => (value) => {
  return !isTimeGreaterThanMaxTime(max, value, timeFormat) ? null : `Hora máxima permitida: ${max}`;
};

export const requiredEmail = (value) => {
  return value && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value) ?
    'correo invalido' : null;
};

export const exactLength = (length) => (value) => {
  const val = String(value);
  return value && val.length !== length ?
    `El valor debe contener ${length} caracteres` :
    null;
};

export const requiredPassword = (value = '') => {
  const val = String(value);
  let errorMessage = 'La contraseña debe tener:\n';
  let conditionalError = '';

  if (val.length < 8) {
    errorMessage += '- Mínimo 8 caracteres.\n';
  }
  if (val.length > 12) {
    errorMessage += '- Máximo 12 caracteres.\n';
  }
  if (!/[A-Z]/g.test(val)) {
    errorMessage += '- Una letra mayúscula.\n';
  }
  if (!/[0-9]/g.test(val)) {
    conditionalError = '- Un número.\n';
  }

  const completeMessage = errorMessage + conditionalError;
  return completeMessage.length > 26 ? completeMessage : null;
};
